import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useMessages = ({ fromMe, dateStart, dateEnd }) => {
    const [loading, setLoading] = useState(true);
    const [count, setCount] = useState(0);

    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            const fetchMessages = async () => {
                try {
                    const { data } = await api.get("/messages-allMe", {
                        params: {
                            fromMe,
                            dateStart,
                            dateEnd,
                        },
                    });

                    if (!isMounted) return;

                    // Safe destructuring with fallback values, count can be a string in postgres
                    if (data && Array.isArray(data.count) && data.count.length > 0 && data.count[0] && data.count[0].count !== undefined) {
                        setCount(Number(data.count[0].count));
                    } else if (data && typeof data.count === 'number') {
                        setCount(data.count);
                    } else if (data && typeof data.count === 'string') {
                        setCount(Number(data.count));
                    } else {
                        console.warn('Invalid data.count structure received:', data);
                        setCount(0);
                    }
                    setLoading(false);
                } catch (err) {
                    if (isMounted) {
                        setLoading(false);
                        toastError(err);
                    }
                }
            };

            fetchMessages();
        }, 500);
        return () => {
            isMounted = false;
            clearTimeout(delayDebounceFn);
        };
    }, [dateStart, dateEnd, fromMe]);

    return { count };
};

export default useMessages;
